export default __webpack_public_path__ + "static/wojtek-wozniak-450f3b9a406d9cb1b1975dff444860b7.jpg";